module.exports = __webpack_public_path__ + "assets/img/help_image01-1.4dc75644.png";